import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialsModule } from '../../materials/materials.module';
import { SavedFilterDialogComponent } from './saved-filter-dialog.component';

@NgModule({
  declarations: [SavedFilterDialogComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialsModule],
  exports: [SavedFilterDialogComponent],
})
export class SavedFilterDialogModule {}
